import { Component } from '@angular/core';
import { FeedbackPlatformReviewThankYouNoteEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Review Thank You Notes') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformreviewthankyounote-form',
    templateUrl: './feedbackplatformreviewthankyounote.form.component.html'
})
export class FeedbackPlatformReviewThankYouNoteFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformReviewThankYouNoteEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

